﻿'use strict';

angular.module('ntmApp').factory('DragStaffIntoResourcePool', ['DraggingObject', 'DailyPlanService', 'FlashService', 'DailyPlanConfirmationService', 'WatchDndTargetsService', 'Constants',
    function (DraggingObject, DailyPlanService, FlashService, DailyPlanConfirmationService, WatchDndTargetsService, Constants) {

        function DragStaffIntoResourcePool(context) {

            var self = this;

            var onStartDraggingEvent = null;
            var onEndDraggingEvent = null;

            self.startDragging = function (activity) {

                if (onStartDraggingEvent) {
                    var allowed = onStartDraggingEvent();

                    if (allowed) {
                        self.DraggingObject.setDraggingObject(activity);
                    }
                }
            };

            self.drag = function (draggingToRPType, activity, location, staff) {

                var request = {
                    facilityCode: location.facilityCode,
                    roomNumber: location.roomNumber,
                    date: moment(context.TopBar.dateDisplayed),
                    personId: staff.assigneeId

                };

                var confirmationMessage = false;
                var successMessage = '';
                var alertData = {};

                var moveRoomStaffToResourcePool = function () {
                    var loadingModal = FlashService.Loading();
                    DailyPlanService.DragIntoResourcePool(request).then(function (result) {

                        loadingModal.dismiss();

                        if (result.success) {

                            if (onEndDraggingEvent) {
                                onEndDraggingEvent();
                            }

                            FlashService.Success(successMessage);
                        }
                    });
                };

                switch (draggingToRPType) {
                    case 'singleActivity':
                        successMessage = location.roomNumber ? getRoomSuccessMessage(draggingToRPType, activity, location, staff) : getOtherSuccessMessage(draggingToRPType, activity, location, staff);
                        request.scheduleIds = [activity.scheduleId];

                        moveRoomStaffToResourcePool();
                        break;
                    case 'activityGroup':
                        successMessage = location.roomNumber ? getRoomSuccessMessage(draggingToRPType, activity, location, staff) : getOtherSuccessMessage(draggingToRPType, activity, location, staff);
                        request.scheduleIds = [];

                        var assigneeGroupActivitiesList = [];

                        activity.items.filter(function (activityItem) {
                            if (activityItem.assignmentId === staff.assigneeId) {
                                assigneeGroupActivitiesList.push(activityItem);
                            }
                        });

                        var assigneeGroupActivitiesInNewStatusList = assigneeGroupActivitiesList.filter(function (activityItem) {
                            return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                        });

                        var startMoveActivityGroupStaffToResourcePool = function () {
                            confirmationMessage = false;

                            assigneeGroupActivitiesList.forEach(function (activityItem) {
                                if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId) || activityItem.activityStatusId === Constants.ActivityStatus.Replaced) {
                                    request.scheduleIds.push(activityItem.scheduleId);
                                }
                            });

                            moveRoomStaffToResourcePool();
                        };

                        if (assigneeGroupActivitiesInNewStatusList.length === 0) {
                            FlashService.Error("{0} has already started or completed every activity in this group. Nothing can be un-assigned.".format(staff.assigneeName), true);
                        } else if (assigneeGroupActivitiesInNewStatusList.length !== assigneeGroupActivitiesList.length) {
                            confirmationMessage = "Some activities have already been started and/or completed by {0}. Only the activities that are not started will be un-assigned.".format(staff.assigneeName);
                            alertData = { confirmButtonText: 'Un-assign anyway' };

                            DailyPlanConfirmationService.MoveStaffFromRoomDetailsToResourcePool(confirmationMessage, alertData)
                                           .Yes(startMoveActivityGroupStaffToResourcePool)
                                           .Ask();
                        } else {
                            startMoveActivityGroupStaffToResourcePool();
                        }
                        break;
                    case 'location':
                        staff = getPreparedStaffData(staff);

                        successMessage = location.roomNumber ? getRoomSuccessMessage(draggingToRPType, activity, location, staff) : getOtherSuccessMessage(draggingToRPType, activity, location, staff);
                        request.scheduleIds = [];
                        var assigneeLocationActivitiesList = [];
                        var assigneeLocationActivitiesInNewStatusList = [];

                        //Room Activities
                        if (location.roomNumber) {

                            var startMoveRoomStaffToResourcePool = function () {
                                confirmationMessage = false;

                                //DnD 2 level
                                if (!activity || !activity.length) {
                                    assigneeLocationActivitiesList.forEach(function (activityItem) {
                                        if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId) || activityItem.activityStatusId === Constants.ActivityStatus.Replaced) {
                                            request.scheduleIds.push(activityItem.scheduleId);
                                        }
                                    });

                                    moveRoomStaffToResourcePool();
                                } //DnD 3 level
                                else {
                                    assigneeLocationActivitiesList.forEach(function (activityItem) {
                                        if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId)) {
                                            request.scheduleIds.push(activityItem.scheduleId);
                                        }
                                    });

                                    moveRoomStaffToResourcePool();
                                }
                            };

                            var preDNDConfirmation = function () {
                                confirmationMessage = "Are you sure you want to un-assign {0} from {1} for this day?".format(staff.assigneeName, location.roomNumber);

                                DailyPlanConfirmationService.MoveStaffFromRoomDetailsToResourcePool(confirmationMessage)
                                                   .Yes(startMoveRoomStaffToResourcePool)
                                                   .Ask();
                            };

                            //DnD 2 level, no activities on client, need to get from DB
                            if (!activity || !activity.length) {
                                request.room = request.roomNumber;

                                DailyPlanService.GetRoomActivities(request).then(function (result) {
                                    var roomActivities = result.data.roomActivityGroups;

                                    roomActivities.forEach(function (activityGroup) {
                                        activityGroup.items.filter(function (activityItem) {
                                            if (activityItem.assignmentId === staff.assigneeId) {
                                                assigneeLocationActivitiesList.push(activityItem);
                                            }
                                        });
                                    });

                                    assigneeLocationActivitiesInNewStatusList = assigneeLocationActivitiesList.filter(function (activityItem) {
                                        return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                                    });

                                    if (assigneeLocationActivitiesInNewStatusList.length === 0) {
                                        FlashService.Error("{0} has already started or completed every activity in this room. Nothing can be un-assigned.".format(staff.assigneeName), true);
                                    } else if (assigneeLocationActivitiesInNewStatusList.length !== assigneeLocationActivitiesList.length) {
                                        confirmationMessage = "Some activities have already been started and/or completed by {0}. Only the activities that are not started will be un-assigned.".format(staff.assigneeName);
                                        alertData = { confirmButtonText: 'Un-assign anyway' };

                                        DailyPlanConfirmationService.MoveStaffFromRoomDetailsToResourcePool(confirmationMessage, alertData)
                                                       .Yes(startMoveRoomStaffToResourcePool)
                                                       .Ask();
                                    }
                                    else {
                                        preDNDConfirmation();
                                    }
                                });
                            } //DnD 3 level
                            else {
                                activity.forEach(function (activityGroup) {
                                    activityGroup.items.filter(function (activityItem) {
                                        if (activityItem.assignmentId === staff.assigneeId) {
                                            assigneeLocationActivitiesList.push(activityItem);
                                        }
                                    });
                                });

                                assigneeLocationActivitiesInNewStatusList = assigneeLocationActivitiesList.filter(function (activityItem) {
                                    return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                                });

                                if (assigneeLocationActivitiesInNewStatusList.length === 0) {
                                    FlashService.Error("{0} has already started or completed every activity in this room. Nothing can be un-assigned.".format(staff.assigneeName), true);
                                } else if (assigneeLocationActivitiesInNewStatusList.length !== assigneeLocationActivitiesList.length) {
                                    confirmationMessage = "Some activities have already been started and/or completed by {0}. Only the activities that are not started will be un-assigned.".format(staff.assigneeName);
                                    alertData = { confirmButtonText: 'Un-assign anyway' };

                                    DailyPlanConfirmationService.MoveStaffFromRoomDetailsToResourcePool(confirmationMessage, alertData)
                                                   .Yes(startMoveRoomStaffToResourcePool)
                                                   .Ask();
                                }
                                else {
                                    preDNDConfirmation();
                                }
                            }
                        } //Other Activities
                        else {
                            activity.forEach(function (activityGroup) {
                                activityGroup.items.filter(function (activityItem) {
                                    if (activityItem.assignmentId === staff.assigneeId) {
                                        assigneeLocationActivitiesList.push(activityItem);
                                    }
                                });
                            });

                            assigneeLocationActivitiesInNewStatusList = assigneeLocationActivitiesList.filter(function (activityItem) {
                                return self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId);
                            });

                            var startMoveLocationStaffToResourcePool = function () {
                                confirmationMessage = false;

                                assigneeLocationActivitiesList.forEach(function (activityItem) {
                                    if (self.doesActivityStatusAllowActivityChanging(activityItem.activityStatusId) || activityItem.activityStatusId === Constants.ActivityStatus.Replaced) {
                                        request.scheduleIds.push(activityItem.scheduleId);
                                    }
                                });

                                moveRoomStaffToResourcePool();
                            };

                            if (assigneeLocationActivitiesInNewStatusList.length === 0) {
                                FlashService.Error("{0} has already started or completed every activity in this room. Nothing can be un-assigned.".format(staff.assigneeName), true);
                            } else if (assigneeLocationActivitiesInNewStatusList.length !== assigneeLocationActivitiesList.length) {
                                confirmationMessage = "Some activities have already been started and/or completed by {0}. Only the activities that are not started will be un-assigned.".format(staff.assigneeName);
                                alertData = { confirmButtonText: 'Un-assign anyway' };

                                DailyPlanConfirmationService.MoveStaffFromRoomDetailsToResourcePool(confirmationMessage, alertData)
                                               .Yes(startMoveLocationStaffToResourcePool)
                                               .Ask();
                            } else {
                                startMoveLocationStaffToResourcePool();
                            }
                        }
                        break;
                }

            };

            self.endDragging = function () {
                if (!WatchDndTargetsService.DKeyPressed) {
                    self.DraggingObject.releaseDraggingObject();
                }
            };

            self.onStartDragging = function (event) {
                onStartDraggingEvent = event;
                return self;
            };

            self.onEndDragging = function (event) {
                onEndDraggingEvent = event;
                return self;
            };

            self.doesActivityStatusAllowActivityChanging = function (activityStatusId) {
                return activityStatusId === Constants.ActivityStatus.NotStarted || activityStatusId === Constants.ActivityStatus.Lapsed;
            };

            var getPreparedStaffData = function (staff) {
                if (staff) {
                    staff.assigneeId = !staff.assigneeId ? staff.personId : staff.assigneeId;
                    staff.assigneeName = !staff.assigneeName ? staff.name : staff.assigneeName;

                    return staff;
                }

                return null;
            };

            var getRoomSuccessMessage = function (draggingToRPType, activity, location, staff) {
                var message = '';

                switch (draggingToRPType) {
                    case 'singleActivity':
                        message = staff + ' successfully removed from the activity.';
                        break;
                    case 'activityGroup':
                        message = staff.assigneeName + ' successfully removed from ' + activity.name + ' for this day.';
                        break;
                    case 'location':
                        message = staff.assigneeName + ' successfully removed from ' + location.roomNumber + ' for this day.';
                        break;

                    default: break;
                }

                return message;
            };

            var getOtherSuccessMessage = function (draggingToRPType, activity, location, staff) {
                var message = '';

                switch (draggingToRPType) {
                    case 'singleActivity':
                        message = staff + ' successfully removed from the activity.';
                        break;
                    case 'activityGroup':
                        message = staff.assigneeName + ' successfully removed from their area activities for this day.';
                        break;
                    case 'location':
                        message = staff.assigneeName + ' successfully removed from their facility activities for this day.';
                        break;

                    default: break;
                }

                return message;
            };

            function initialize() {
                self.DraggingObject = new DraggingObject();
            }

            initialize();

        }

        return (DragStaffIntoResourcePool);

    }]);